export function selectVideoSource(
    sources,
    mobile = window.matchMedia("(max-width: 767px)").matches,
) {
    if (typeof sources === "string") {
        return sources;
    }

    return mobile && sources.mobile ? sources.mobile : sources.desktop;
}

export function attachVideoSource(video) {
    if (video.hasAttribute("src")) {
        return;
    }

    video.src = selectVideoSource({ desktop: video.dataset.src, mobile: video.dataset.mobileSrc });
}

function initResponsiveVideos() {
    document.querySelectorAll("video[data-responsive-video]").forEach(attachVideoSource);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initResponsiveVideos, { once: true });
} else {
    initResponsiveVideos();
}
